import React from 'react'
import usePageMeta from '../hooks/usePageMeta'
import Header from '../components/header/Header'
import Navbar from '../components/navbar/Navbar'
import Mission from '../components/mission/Mission'
import Curriculum from '../components/curriculum/Curriculum'
import Reviews from '../components/reviews/Reviews'
import Footer from '../components/footer/Footer'

export default function LandingPage() {
  usePageMeta({
    title: 'Learning In Motion Preschool | Preschool & VPK in Cooper City, FL',
    description: 'Gold Seal accredited preschool in Cooper City, FL. Frog Street curriculum for toddlers through VPK, open 6:30am-6:30pm.',
    path: '/',
  })

  return (
    <>
      <Navbar/>
      <Header/>
      <Mission/>
      <Curriculum/>
      <Reviews/>
      <Footer/>
    </>
  )
}
